import styled from 'styled-components';
import { GlobalToken } from 'antd';
import { StageCard } from '@/comp/StationStages/styled';

export const ValueDashboardContainer = styled.div<{ theme: { token: GlobalToken } }>`
  flex-grow: 0;
  padding: ${({ theme: { token } }) => token.paddingMD}px;
  overflow-y: scroll;
  width: 100%;

  .loader {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 75px;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 1;

    .anticon-loading {
      font-size: ${({ theme: { token } }) => token.fontSizeHeading1}px;
    }
  }

  .two-cards-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 1280px;
    margin-top: ${({ theme: { token } }) => token.marginXL}px;
  }

  .top-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;

    @media (max-width: 1024px) {
      flex-direction: column-reverse;
      align-items: stretch;
    }

    .eco-select-station {
      padding: 0;
      width: 310px;

      @media (max-width: 1024px) {
        width: 100%;
        margin-top: 1rem;
      }
    }

    ${StageCard} {
      margin: 0;
      flex: 1;
    }

    .baseline-period {
      font-size: ${({ theme: { token } }) => token.fontSize}px;

      .text {
        color: ${({ theme: { token } }) => token.colorBorder};
      }
    }
  }

  .grid-container {
    display: grid;
    grid-template-columns: 0fr;
    grid-template-rows: auto;
    grid-template-areas:
      'energy-savings insights'
      'yearly-view yearly-view'
      'leakage station-risk'
      'station-risk-yearly-view station-risk-yearly-view';

    @media (max-width: 1440px) {
      grid-template-columns: 1fr;
      grid-template-areas:
        'energy-savings'
        'yearly-view'
        'insights'
        'leakage'
        'station-risk'
        'station-risk-yearly-view';
    }

    .yearly-view {
      max-width: 1288px;
      max-height: 450px;
      grid-area: yearly-view;
    }

    .insight {
      grid-area: insights;
      width: fit-content;
      height: fit-content;
    }

    .leakage {
      grid-area: leakage;
      width: fit-content;
    }

    .station-risk {
      grid-area: station-risk;
      height: fit-content;
      width: fit-content;
    }

    .station-risk-yearly-view {
      grid-area: station-risk-yearly-view;
      display: none;
    }

    .energy-savings {
      grid-area: energy-savings;
      width: fit-content;
    }

    .card-item {
      margin-right: ${({ theme: { token } }) => token.marginXXL}px;
      margin-top: ${({ theme: { token } }) => token.marginXL}px;
    }
  }
`;

interface ContainerProps {
  $isWidget: boolean;
  theme: {
    token: GlobalToken;
  };
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: absolute;

  .year-navigation {
    display: flex;
    align-items: center;
    position: absolute;
    ${props => (props.$isWidget ? 'left:0;' : 'left:45%; position:absolute; transformX(-50%);')}
  }

  .chevron {
    height: 18px;
    width: 18px;
    &.left {
      transform: rotate(90deg);
    }
    &.right {
      transform: rotate(-90deg);
    }
  }
  .ant-btn {
    margin: 0 ${({ theme: { token } }) => token.margin}px;
    width: auto;
    height: auto;

     &.disabled {
      opacity: 0.3;
    }
    
    &.enabled {
      opacity: 1;
    }
  }

  .year-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .year-label {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    margin-right: ${({ theme: { token } }) => token.marginXS}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }

  .year-number {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    display: flex;
    align-items: center;
    color: ${({ theme: { token } }) => token.colorText};
  }

  .baseline-period-container {
    display: flex;
    gap: 10px;
    margin-left: auto;
    align-items: center;
    .baseline-period-label {
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      color: ${({ theme: { token } }) => token.colorTextSecondary};
    }

   .baseline-period-number {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      margin-right: 1.5rem;
    } 
   }
  }
`;
